export interface SubmenuPathMatch {
  url: string;
  inactive?: boolean;
  isPathActive?: (pathname: string) => boolean;
}

/** True when this path is the menu URL itself or a deeper segment under it. */
export function pathnameMatchesMenuUrl(pathname: string, url: string): boolean {
  return pathname === url || pathname.startsWith(`${url}/`);
}

export function submenuMatchesPathname(pathname: string, sub: SubmenuPathMatch): boolean {
  if (sub.inactive) return false;
  if (sub.isPathActive?.(pathname)) return true;
  return pathnameMatchesMenuUrl(pathname, sub.url);
}

/**
 * Among sibling submenu URLs that match the pathname, only the longest URL is considered active
 * (e.g. /payroll/eor matches both /payroll and /payroll/eor — only the latter is active).
 */
export function getLongestMatchingSubmenuUrl(
  pathname: string,
  subItems: readonly SubmenuPathMatch[]
): string | undefined {
  const matching = subItems
    .filter((sub) => submenuMatchesPathname(pathname, sub))
    .map((sub) => sub.url);
  if (matching.length === 0) return undefined;
  return matching.reduce((a, b) => (b.length > a.length ? b : a));
}

export function isSubmenuItemActive(
  pathname: string,
  subUrl: string,
  subItems: readonly SubmenuPathMatch[]
): boolean {
  const longest = getLongestMatchingSubmenuUrl(pathname, subItems);
  return longest !== undefined && subUrl === longest;
}
